import React, { useEffect, useState } from 'react';

import { useRouter } from 'next/router';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import {
  GET_CITY_LINK,
  GET_CITY_LINK_INTERFACE,
  GET_REVIEW_STATUS,
  GET_REVIEW_STATUS_INTERFACE
} from '../../api/cityReviewLinks';
import client from '../../apollo-client';
import UPDATE_BOOKING_REVIEW_STATUS, {
  UPDATE_BOOKING_REVIEW_STATUS_INTERFACE
} from '../../api/updateBookingReviewStatus';
import ReviewModal from './Modal';
import FeedBackModal from './FeedBackModal';

interface IProps {
  id?: any;
}
const ReviewRequest = ({ id }: IProps) => {
  const [show, setShow] = useState<boolean>(false);
  const [showFeedback, setShowFeedBack] = useState<boolean>(false);

  const router = useRouter();

  const { data: review } = useQuery<GET_REVIEW_STATUS_INTERFACE>(
    GET_REVIEW_STATUS,
    {
      variables: {
        id
      }
    }
  );

  const [fetchCityLink, { data, error }] =
    useLazyQuery<GET_CITY_LINK_INTERFACE>(GET_CITY_LINK, {
      variables: {
        id
      }
    });

  const [triggerReviewUpdate, { data: reviewStatus }] =
    useMutation<UPDATE_BOOKING_REVIEW_STATUS_INTERFACE>(
      UPDATE_BOOKING_REVIEW_STATUS
    );

  useEffect(() => {
    console.log('this is the review', review);
    if (review && review?.review.length > 0) {
      fetchCityLink();
      setShow(true);
    } else if (review && !review?.review[0]) {
      setShow(false);
      router.push('/reviews');
    }
  }, [review]);

  return (
    <>
      <ReviewModal
        data={data}
        show={show}
        setShow={setShow}
        setShowFeedBack={setShowFeedBack}
      />
      <FeedBackModal
        data={data}
        setShow={setShow}
        showFeedBack={showFeedback}
        setShowFeedBack={setShowFeedBack}
        id={id}
        customer={data?.city[0].customer.contactName}
        guide={data?.city[0].guide ? data?.city[0].guide.full_name : ''}
        tour={data?.city[0].product.name}
        tourDate={data?.city[0].tour_date}
        tourTime={data?.city[0].tour_time}
        guidePhone={data?.city[0].guide ? data?.city[0].guide.phone : ''}
        customerPhone={
          data?.city[0].customer.phone
            ? data?.city[0].customer.phone
            : data?.city[0].customer.secondaryPhone
        }
      />
      ,
    </>
  );
};
interface Params {
  query: {
    id: string;
  };
}

export default ReviewRequest;
